import { useState, useEffect } from "react";
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import { useParams } from "react-router-dom";
import { getUserSession } from "../../../../core/util/core/Session";
import config from '../../../config/config';
import Fetch from "../../../../core/util/core/Fetch";
import { chooseProfileFilter } from "../../../helpers/chooseProfileFilter";
import sleep from 'sleep-promise';
import { useKeysStore } from "../../../../core/store/useKeysStore";

function Form() {
    const { keys } = useKeysStore();
    const session = getUserSession();
    const [form, setForm] = useState();
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const { id } = useParams();

    const profileFilter = chooseProfileFilter()

    const path = '/contracts/';
    const paths = {
        endpointSave: config.endpoints.backend + 'contracts/save',
        endpointGetById: config.endpoints.backend + 'contracts/getById',
        endpointGetByContractNumber: config.endpoints.backend + 'contracts/getByContractNumber',
        endpointGetAllProjects: config.endpoints.backend + 'projects/getall',
        endpointGetAllProcesses: config.endpoints.backend + 'processes/getall',
        endpointGetAllSuppliers: config.endpoints.backend + 'people/getSuppliers',
        endpointGetAllContractTypes: config.endpoints.backend + 'contracttypes/getall',
        endpointGetAllContractStatuses: config.endpoints.backend + 'contractstatuses/getall',

        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleAdd: "Novo Contrato",
        labelTitleEdit: "Editar Contrato",
        labelTitleView: 'Visualizar Contrato'
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            fields: [
                {
                    name: 'pdc_project_id',
                    type: 'select',
                    label: 'Projeto',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllProjects,
                        label: 'project_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    validations: {
                        required: false
                    },
                    columnSize: 6,
                    handleChange: async (element, field, values) => {
                        values.pdc_process_id = null;
                        let form = getForm(values);
                        form.fields[1].autoFocus = true;
                        setForm(form);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />)
                    }
                },
                {
                    name: 'pdc_process_id',
                    type: 'select',
                    label: 'Processo',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllProcesses,
                        label: 'process_number',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter,
                                pdc_project_id: values.pdc_project_id
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 6,
                },
                {
                    name: 'pdc_people_id',
                    type: 'select',
                    label: 'Fornecedor',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllSuppliers,
                        label: 'corporate_name',
                        value: 'id',
                        params: {
                            filter: {
                                pdc_company_id: session.loggedUserInfo.pdc_company_id
                            },
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'pdc_contract_type_id',
                    type: 'select',
                    label: 'Tipo de Contrato',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllContractTypes,
                        label: 'name',
                        value: 'id'
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 6,
                },
                {
                    name: 'pdc_contract_status_id',
                    type: 'select',
                    label: 'Situação',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllContractStatuses,
                        label: 'name',
                        value: 'id'
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 6,
                },
                {
                    name: 'contract_number',
                    type: 'text',
                    mask: '999999/9999',
                    label: 'Número do Contrato',
                    validations: {
                        required: true,
                        contract_number: true
                    },
                    columnSize: 12
                },
                {
                    name: 'months_amount',
                    type: 'integer',
                    label: 'Quantidade de Meses',
                    validations: {
                        required: false
                    },
                    columnSize: 6
                },
                {
                    name: 'monthly_value',
                    type: 'decimal',
                    label: 'Valor Mensal',
                    validations: {
                        required: false
                    },
                    columnSize: 6,
                },
                {
                    name: 'days_amount',
                    type: 'integer',
                    label: 'Quantidade de Dias',
                    validations: {
                        required: false
                    },
                    columnSize: 6
                },
                {
                    name: 'daily_value',
                    type: 'decimal',
                    label: 'Valor Diário',
                    validations: {
                        required: false
                    },
                    columnSize: 6,
                },
                {
                    name: 'signature_date',
                    type: 'date',
                    label: 'Data de Assinatura',
                    validations: {
                        required: true
                    },
                    columnSize: 4
                },
                {
                    name: 'effective_date',
                    type: 'date',
                    label: 'Data de Vigência',
                    validations: {
                        required: true
                    },
                    columnSize: 4
                },
                {
                    name: 'payment_condition',
                    type: 'text',
                    label: 'Condição de Pagamento',
                    validations: {
                        required: true
                    },
                    columnSize: 4
                },
                {
                    name: 'file',
                    type: 'fileS3',
                    extensionAccept: '.jpeg,.jpg,.png,.ico,.pdf,.xlsx,.docx',
                    limitFileSize: keys?.limitFileSizeDefault,
                    label: 'Arquivo',
                    validations: {
                        required: true
                    },
                    columnSize: 6
                },
                {
                    name: 'observation',
                    type: 'textarea',
                    label: 'Observação',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                }
            ],
            customValidators: {
                contract_number: (value, options, key, attributes) => {
                    const checkContractNumber = async (value) => {
                        const mask = /^\d{6}\/\d{4}$/
                        if (mask.test(value)) {
                            if (attributes.pdc_project_id) {

                                const post = {
                                    contract_number: value,
                                    pdc_project_id: attributes.pdc_project_id
                                };

                                const contract = await Fetch.post(paths.endpointGetByContractNumber, post);

                                if (contract.id && contract.id != id) {
                                    return '^O número do contrato já existe';
                                }
                            }
                        } else {
                            return "^O formato deve ser 000000/0000 (Número/Ano)";
                        }
                    }
                    return checkContractNumber(value);
                }
            },
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};

            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }

            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
